import { Card, CardHeader, CardContent } from '@/components/ui/Card';
import { Badge } from '@/components/ui/Badge';
import { EmptyState } from '@/components/ui/EmptyState';
import { Building2 } from 'lucide-react';
import { formatRelativeTime } from '@/utils/formatters';
import { Link } from 'react-router-dom';

interface UserSubscriptionCardProps {
  user: any;
}

export function UserSubscriptionCard({ user }: UserSubscriptionCardProps) {
  // API returns organisationMemberships: [{ uuid, role, joinedAt, organisation: { uuid, name, slug } }]
  const memberships = user?.organisationMemberships || user?.organisations || [];

  return (
    <Card>
      <CardHeader title="Abonnements & Organisations" description={memberships.length > 0 ? `${memberships.length} organisation(s)` : undefined} />
      <CardContent>
        {memberships.length > 0 ? (
          <div className="space-y-2">
            {memberships.map((m: any) => {
              const orgName = m.organisation?.name || m.name || 'N/A';
              const orgUuid = m.organisation?.uuid || m.uuid;
              const role = m.role || 'member';

              return (
                <Link
                  key={m.uuid}
                  to={`/organisations/${orgUuid}`}
                  className="flex items-center justify-between rounded-lg bg-neutral-100 dark:bg-neutral-800/50 p-3 hover:bg-neutral-200 dark:hover:bg-neutral-700/50 transition-colors"
                >
                  <div>
                    <p className="text-sm font-medium text-neutral-700 dark:text-neutral-300">{orgName}</p>
                    {m.joinedAt && (
                      <p className="text-xs text-neutral-500">Rejoint {formatRelativeTime(m.joinedAt)}</p>
                    )}
                  </div>
                  <Badge variant={role === 'owner' ? 'warning' : role === 'admin' ? 'info' : 'neutral'}>{role}</Badge>
                </Link>
              );
            })}
          </div>
        ) : (
          <EmptyState
            message="Aucun abonnement"
            icon={<Building2 className="h-8 w-8" />}
          />
        )}
      </CardContent>
    </Card>
  );
}
